interface ButtonProps {
    children: string
    disabled?: boolean
    tint?: string
    textColor?: string
    onClick?: () => void
}

function Button(props: ButtonProps) {
    function onClick() {
        if (!isDisabled() && props.onClick) props.onClick()
    }

    function isDisabled(): boolean {
        return props.disabled !== undefined && props.disabled
    }

    return (
        <div
            onClick={onClick}
            className={
                "py-2 px-4 w-fit rounded tracking-wide cursor-pointer " +
                (props.tint === undefined
                    ? "bg-primary-500 hover:bg-primary-600 "
                    : props.tint + " ") +
                (props.textColor === undefined ? "text-white" : props.textColor)
            }
            style={{
                cursor: isDisabled() ? "default" : undefined,
                backgroundColor: isDisabled() ? "black" : undefined
            }}
        >
            {props.children}
        </div>
    )
}

export default Button
